/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-empty */
export class Events {
  constructor() {
    this.isMobileApp = process.env.VUE_APP_ENV === 'cordova';
    this.isProduction = process.env.NODE_ENV === 'production';

    // no-inner-declarations
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      dataLayer.push(arguments);
    }

    try {
      if (!this.isMobileApp) {
        gtag('js', new Date());

        gtag('config', 'G-HP9TEYB9NB');
      }
    } catch (err) {
      console.log(err);
    }

    this.login = () => {
      if (!this.isMobileApp) {
        try {
          gtag('event', 'login', {
            method: 'Website',
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.search = (search_term) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'search', {
            search_term,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.selectContent = (clubId) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'select_content', {
            content_type: 'club',
            item_id: clubId,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.purchase = (transaction_id, currency, value, coupon, homePoints, flexiPoints, items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'purchase', {
            currency,
            transaction_id,
            value,
            coupon,
            items: [
              {
                item_id: items.item_id,
                item_name: 'club membership',
                item_list_id: 'club',
                item_list_name: 'clubs',
                price: items.price,
                quantity: 1,
              },
            ],
          });
          this.earnVirtualCurrency('Home', homePoints);
          this.earnVirtualCurrency('Flexi', flexiPoints);
        } catch (err) {
          console.log(err);
        }

        try {
          fbq('track', 'Purchase', {
            content_ids: items.item_id,
            content_name: 'Package Purchased',
            content_type: 'destination',
            currency: 'GBP',
            value,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.addPaymentInfo = (value, items) => {
      try {
        gtag('event', 'add_payment_info', {
          currency: 'GBP',
          value,
          items: [items],
        });
        fbq('track', 'AddPaymentInfo', {
          content_ids: items.item_id,
          content_name: 'Package Purchased',
          currency: 'GBP',
          value,
        });
      } catch (err) {
        console.log(err);
      }
    };

    this.earnVirtualCurrency = (type, points) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'earn_virtual_currency', {
            virtual_currency_name: `${type} Points`,
            value: points,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.spendVirtualCurrency = (type, points) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'spend_virtual_currency', {
            virtual_currency_name: `${type} Points`,
            value: points,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.tutorialBegin = () => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'tutorial_begin', {});
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.tutorialComplete = () => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'tutorial_complete', {});
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.signUpComplete = () => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'sign_up', {
            method: 'Website',
          });
          fbq('track', 'CompleteRegistration', {
            content_name: 'Completed sign up',
            currency: 'GBP',
            value: '1',
            status: 'true',
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.addToCart = (value, items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'add_to_cart', {
            currency: 'gbp',
            value,
            items: [items],
          });
          fbq('track', 'AddToCart', {
            content_ids: items.item_id,
            currency: 'GBP',
            value,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.removeCart = (value, items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'remove_from_cart', {
            currency: 'gbp',
            value,
            items: [items],
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.viewCart = (value, items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'view_cart', {
            currency: 'gbp',
            value,
            items: [items],
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.beginCheckout = (value, coupon, items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'begin_checkout', {
            currency: 'gbp',
            value,
            coupon,
            items: [items],
          });
          fbq('track', 'InitiateCheckout', {
            content_ids: items.item_id,
            content_type: 'destination',
            contents: JSON.stringify([{ id: items.item_id, quantity: 1 }]),
            content_category: 'Club Membership',
            num_items: 1,
            currency: 'GBP',
            value,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.viewItemList = (items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'view_item_list', {
            items,
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.selectItem = (items) => {
      if (!this.isMobileApp && this.isProduction) {
        try {
          gtag('event', 'select_item', {
            items: [items],
          });
        } catch (err) {
          console.log(err);
        }
      }
    };
  }
}
